import React from "react";
import { useSelector } from "react-redux";
import { Stepper, Step, StepLabel, Box, Typography } from "@mui/material";

const TemplateStepperComponent = () => {
  const { activeStep, steps } = useSelector((state) => state.template);

  return (
    <Box sx={{ marginBottom: { xs: 0.5, sm: 0.75, md: 1, lg: 1, xl: 1 }, width: "100%" }}>
      <Stepper
        activeStep={activeStep}
        sx={{
          "& .MuiStepLabel-label": {
            color: (theme) => theme.palette.text.primary,
            fontSize: { xs: "10px", sm: "11px", md: "12px", lg: "14px", xl: "14px" },
            display: { xs: "none", sm: "block", md: "block", lg: "block", xl: "block" },
          },
          "& .MuiStepIcon-root": {
            color: (theme) =>
              theme.palette.mode === "dark"
                ? theme.palette.grey[700]
                : theme.palette.grey[400],
            fontSize: { xs: "20px", sm: "22px", md: "24px", lg: "24px", xl: "24px" },
            "&.Mui-active": {
              color: (theme) => theme.palette.primary.main,
            },
            "&.Mui-completed": {
              color: (theme) => theme.palette.primary.main,
            },
          },
          "& .MuiStepLabel-root": {
            padding: { xs: "4px", sm: "6px", md: "8px", lg: "8px", xl: "8px" },
          },
        }}
      >
        {steps.map((label, index) => (
          <Step key={index}>
            <StepLabel>
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Typography
                  variant="body2"
                  sx={{
                    marginLeft: { xs: 0.5, sm: 0.75, md: 1, lg: 1, xl: 1 },
                    display: { xs: "none", sm: "inline", md: "inline", lg: "inline", xl: "inline" },
                    color: (theme) => theme.palette.text.primary,
                    fontSize: { xs: "10px", sm: "11px", md: "12px", lg: "14px", xl: "14px" },
                  }}
                >
                  {label}
                </Typography>
              </Box>
            </StepLabel>
          </Step>
        ))}
      </Stepper>
    </Box>
  );
};

export default TemplateStepperComponent;
